var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from '@angular/core';
import { API } from './api';
import { BaseProvider } from './base';
import { OptimizeTag } from './boost';
import { BrainVersionType } from './brain';
import { TranslateService } from '@ngx-translate/core';
export var Comprehensiveness;
(function (Comprehensiveness) {
    Comprehensiveness["Quick"] = "Quick";
    Comprehensiveness["Balanced"] = "Medium";
    Comprehensiveness["Thorough"] = "Thorough"; // resourceString('Thorough')
})(Comprehensiveness || (Comprehensiveness = {}));
export var DetectionOptimizationType;
(function (DetectionOptimizationType) {
    DetectionOptimizationType["Fast"] = "Fast";
    DetectionOptimizationType["Balanced"] = "Balanced";
    DetectionOptimizationType["Thorough"] = "Thorough";
    DetectionOptimizationType["Test"] = "Test"; // resourceString('Test')
})(DetectionOptimizationType || (DetectionOptimizationType = {}));
export var OptimizeFor;
(function (OptimizeFor) {
    OptimizeFor["Accuracy"] = "Accuracy";
    OptimizeFor["AverageAccuracy"] = "AverageAccuracy";
    OptimizeFor["LeastFP"] = "LeastFP";
})(OptimizeFor || (OptimizeFor = {}));
export var OptimizeForDescriptions;
(function (OptimizeForDescriptions) {
    OptimizeForDescriptions["Accuracy"] = "Highest Accuracy";
    OptimizeForDescriptions["AverageAccuracy"] = "Highest Average Accuracy";
    OptimizeForDescriptions["LeastFP"] = "Least False Positives"; // resourceString('Least False Positives')
})(OptimizeForDescriptions || (OptimizeForDescriptions = {}));
export var ModelSizing;
(function (ModelSizing) {
    ModelSizing["OptimizeForDataset"] = "OptimizeForDataset";
    ModelSizing["Large"] = "Large";
    ModelSizing["Medium"] = "Medium";
    ModelSizing["Small"] = "Small";
    ModelSizing["Reuse"] = "Reuse";
})(ModelSizing || (ModelSizing = {}));
var DEFAULT_UNKNOWN_TEXT = 'Unknown';
var OptimizationRunsProvider = /** @class */ (function (_super) {
    __extends(OptimizationRunsProvider, _super);
    function OptimizationRunsProvider(api, translate) {
        var _this = _super.call(this) || this;
        _this.api = api;
        _this.translate = translate;
        return _this;
    }
    /**
     * Returns information about the latest optimization run
     * @param {string} datasetIdentifier Dataset's identifier
     */
    OptimizationRunsProvider.prototype.getLatestRun = function (datasetIdentifier, brainVersionType) {
        if (brainVersionType === void 0) { brainVersionType = BrainVersionType.Learning; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.debounce(datasetIdentifier + "/optimization-runs/latest?brainVersionType=" + brainVersionType, function () {
                            return _this.api.get("datasets/" + datasetIdentifier + "/optimization-runs/latest?brainVersionType=" + brainVersionType);
                        }, 250)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.message];
                }
            });
        });
    };
    OptimizationRunsProvider.prototype.getComprehensivenessDescription = function (comprehensiveness) {
        if (!comprehensiveness) {
            return DEFAULT_UNKNOWN_TEXT;
        }
        else if (comprehensiveness === Comprehensiveness.Balanced) {
            // This clause can eventually be removed once the backend stops returning "Medium" comprehensiveness.
            return this.translate.instant('Balanced');
        }
        else {
            return this.translate.instant(comprehensiveness);
        }
    };
    OptimizationRunsProvider.prototype.getTagDescription = function (tag) {
        switch (tag) {
            case OptimizeTag.Small:
                return this.translate.instant('Small');
            case OptimizeTag.Explainability:
                return this.translate.instant('Explainability Enabled');
            case OptimizeTag.Medium:
                return this.translate.instant('Medium');
            case OptimizeTag.Large:
                return this.translate.instant('Large');
            case OptimizeTag.HiFiUltraFine:
                return this.translate.instant('Ultrafine');
            case OptimizeTag.HiFiFine:
                return this.translate.instant('Fine');
            case OptimizeTag.HiFiRegular:
                return this.translate.instant('Regular');
            case OptimizeTag.HiFiCoarse:
                return this.translate.instant('Coarse');
            case OptimizeTag.Reuse:
                return this.translate.instant('Use same model architecture as previous brain version');
            default:
                return this.translate.instant('Optimize for dataset');
        }
    };
    OptimizationRunsProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [API, TranslateService])
    ], OptimizationRunsProvider);
    return OptimizationRunsProvider;
}(BaseProvider));
export { OptimizationRunsProvider };
//# sourceMappingURL=optimization-runs.js.map


// WEBPACK FOOTER //
// ./src/providers/optimization-runs.ts.pre-build-optimizer.js